"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;
var _index = require("./../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Message = exports.Message = _styledComponents["default"].span.withConfig({
  displayName: "Message",
  componentId: "sc-15vkh7g-0"
})(["padding-block:", ";flex:", ";"], (0, _index.cssSpacing)('tighter-5', '2px'), function (props) {
  return props.$align === 'center' ? undefined : 1;
});